import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { result } from 'underscore';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';
import { User } from '../entities/user';
import { GenericService } from '../generic.service';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ProfileComponent implements OnInit {


  /*public errorMessage : string = '';
  public successMessage : string = '';
  public justSaved  : String;
  public MsgError  : String;*/
  public pwd: string;

  public user: User;
  public currentUser : User;
  public nom : string;
  public prenom : string
  public email : string;
  public telephone : string;
  public userPassword: string;
  public role : string;

  public dataUser = {
          email: '',
        };


  constructor(public _authService: AuthService, private _genericService: GenericService, _router: Router, private _notifyService: NotificationService) {

   }

  ngOnInit() {
    this._authService.checkCredentials();
    this.getcurrentUser();
  }
  // Récupérer les informations de l'utilisateur courant
  getcurrentUser(){
    this._genericService.getResource(environment.currentUser, true, 0)
    .subscribe(
      data => {
        this.currentUser = data;
        this.nom = this.currentUser.nom; 
        this.prenom = this.currentUser.prenom;
        this.email = this.currentUser.email;
        this.telephone = this.currentUser.telephone
        this.role = this.currentUser.roles[0].role;
      },
      error => {
      }
    )
  }

  updateCurrentUser(currentUser){
    if (confirm( "Voulez vous vraiment modifier votre profil ?")) {
      this.currentUser = currentUser
      this.currentUser.nom = this.currentUser.nom.trim().replace(/-/g, " ")
      .replace(/á|à|â|ä|a̧|ǎ|ã/gi,"a").replace(/ć|c̀|ĉ|c̈|ç|č|c̃/gi,"c")
      .replace(/é|è|ê|ë|ȩ|ě|ẽ/gi,"e").replace(/í|ì|î|ï|i̧|ǐ|ĩ/gi,"i")
      .replace(/ó|ò|ô|ö|o̧|ǒ|õ/gi, "o").replace(/ú|ù|û|ü|u̧|ǔ|ũ/gi,"u").replace(/  +/g, ' ')
      .toUpperCase();

      this.currentUser.email = this.currentUser.email.trim().toLowerCase();

      this.currentUser.telephone = this.currentUser.telephone.trim();

      this._genericService.saveResource(environment.updateCurrentUser, currentUser, true, environment.contentTypes.json)
      .subscribe(
        data => {
          this._notifyService.showSuccess("Votre profil à été modifié", "Edit profil", 4000)
          this.reloadPage();
          /*window.scroll(0,0);
          this.successMessage = "Votre profil à été modifié";
          this.justSaved = this.successMessage;
          this.resetSuccesMessage();*/
          //window.location.reload();
        },
        error => {
          //this.showSpinner = false;
          //window.scroll(0,0);
          this._notifyService.showError("Une erreur de modification de votre profil", "Edit profil", 4000);
          /*this.errorMessage = "Une erreur de modification de votre profil";
          this.MsgError = error.message;
          this.resetErrorMessage();*/
        }
       );
      
    } else {
      this.currentUser = currentUser;
    }
    
  }

  //afficher le message de succes
  reloadPage(){
    setTimeout(()=>{
      window.location.reload();
    }, 4000);
  }

  //afficher le message d'erreur
  /*resetErrorMessage(){
    setTimeout(()=>{
      this.MsgError = '';
    }, 4000);
  }*/


  // changer le mot de passe de l'utilisateur
  updateMyPassword(){
    //this.clearMessages();
    if(this.dataUser.email != ''){
      this._authService.updatePassword(this.dataUser.email)

    .subscribe(
      data =>{
        this._notifyService.showSuccess("Veuillez consulter votre boite mail ! Nous vous avons envoyé un mail de changement de mot de passe.", "Update password", 3000)
      },
      error =>{
        this._notifyService.showError("Une erreur est survenue !", "Update password", 4000)
      }
    );
    }else{
      this._notifyService.showError("Email obligatoire", "Update password", 4000)

    }
  }

  /*clearMessages(){
    this.errorMessage = '';
    this.successMessage = '';
  }*/



}





// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts